<app-loader *ngIf="isDisabled"></app-loader>
<div>
    <div class="row">
        &nbsp;&nbsp;&nbsp;<div class="col-md-2 px-1">
            <label class="Label">Status</label>
            <select class="form-select" aria-label="Status" placeholder="Status" title="Status" name="status"
                [(ngModel)]="Status" required (change)="onchange()">
                <option value="All">All</option>
                <option value="Active">Active</option>
                <option value="Deactive">Deactive</option>
            </select>
        </div>
        <div class="col-md-3 px-1">
            <label class="Label">Branch</label>
            <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                [(ngModel)]="BranchId" (change)="onchange()" placeholder="Select Branch">
            </ng-select>
        </div>
        <div class="col"><br>
            <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="getData()">
                <i class="bi bi-search" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Search':'Loading...'}}
            </button>
        </div>
        <div class="col-auto"> <br>
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-geo-alt" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Location':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Site Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                        <th scope="col">Branch Name</th>
                        <th scope="col">Client Name</th>
                        <th scope="col">Site Code</th>
                        <th scope="col">Site Name</th>
                        <th scope="col">Active</th>

                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of SiteMasterData; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="onEditClick(site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                        <td>{{ site['BranchName'] }}</td>
                        <td>{{ site['ClientGroupName'] }}</td>
                        <td>{{ site['SiteCode'] }}</td>
                        <td>{{ site['SiteName'] }}</td>
                        <td>{{ site['Active'] ? 'Yes' : 'No'}}</td>

                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">

                    <div class="row">
                    </div>
                    <div class="row">
                    </div>
                </div>
                <div class="col-auto">
                    <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
                        (click)="exportToExcel('Location Master','SiteMaster_data')">
                        <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Site Master':'Loading...'}}
                    </button>
                    &nbsp;<button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
                        (click)="exportToExcel('Location Manpower Master','SiteManpower_data')">
                        <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Site Manpower':'Loading...'}}
                    </button>
                    &nbsp;<button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
                        (click)="exportToExcel('Location Details','SiteDetails_data')">
                        <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Site Details':'Loading...'}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>